module.exports = __webpack_public_path__ + "static/img/xxl-logo.d6977b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/xxl-logo.png
// module id = /UxI
// module chunks = 2